import CurrencyField from "../Bc-Fields/Bc-Currency/Bc-Currency";
import InputField from "../Bc-Fields/Bc-Input/Bc-Input";
import NumberField from "../Bc-Fields/Bc-Number/BcNumber";
import SelectField from "../Bc-Fields/Bc-Select/Bc-Select";
import TextAreaField from "../Bc-Fields/Bc-Textarea/Bc-Textarea";
import { BcFieldsProps } from "../../interface/props/bcfield";
import MultiSelect from "../Bc-Fields/Bc-Multiselect/BC-Multiselect";
import { UseFormSetValue, UseFormGetValues, UseFormResetField } from 'react-hook-form';
import ArrayField from "../Bc-Fields/Bc-Array/Bc-Array";
import FileField from "../Bc-Fields/Bc-File/Bc-File";

const SwitchFields = ({ field, register, isRequired, setValue, errors, getValues, resetField, unregister }: BcFieldsProps) => {
  const fieldsSwitch = () => {
    switch (field.type) {
      case "select":
        return (
          <SelectField
            field={field}
            register={register}
            isRequired={isRequired}
          />
        );
      case "textarea":
        return (
          <TextAreaField
            field={field}
            register={register}
            isRequired={isRequired}
            errors={errors}
          />
        );
      case "number":
        return (
          <NumberField
            field={field}
            register={register}
            isRequired={isRequired}
            errors={errors}
          />
        );
      case "currency":
        return (
          <CurrencyField
            field={field}
            register={register}
            isRequired={isRequired}
            errors={errors}
          />
        );
      case "multi_select":
        return (
          <MultiSelect field={field} register={register} setValue={setValue as UseFormSetValue<any>} legend={`Seleccion multiple de ${field.label}`} isRequired={isRequired as boolean}  />
        );
      case "array_fields":
        return (
          <ArrayField field={field} registerArray={register} setValue={setValue as UseFormSetValue<any>} getValues={getValues as UseFormGetValues<any>} unregister={unregister} isRequired={isRequired as boolean} />
        );
        case "file":
          return (
            <FileField field={field} register={register} setValue={setValue as UseFormSetValue<any>} resetField={resetField as UseFormResetField<any>} isRequired={isRequired as boolean} />
          );
      default:
        return (
          <InputField
            field={field}
            register={register}
            isRequired={isRequired}
            errors={errors}
          />
        );
    }
  };

  return <>{fieldsSwitch()}</>;
};

export default SwitchFields;
